<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TableRole ref="table" :show-title="true"></TableRole>
    </v-col>
    <v-col cols="12" class="text-right">
      <v-btn @click="createItem()">Neu erstellen</v-btn>
    </v-col>
  </v-row>
</template>


<script>
//import Vue from 'vue'
import TableRole from "../tables/TableRoles";
import Vue from "vue";

export default {
  name: 'BenutzerRollen',
  components: {TableRole},
  data() {
    return {}
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiRole.createRole({}, this.onItemCreated)
    },
    onItemCreated: function (newItem) {
      console.log('onItemCreated', newItem)
      this.$router.push('/Rollen/' + newItem.guid)
    }
  },
  mounted() {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
